import { render, staticRenderFns } from "./TutorialDocent.vue?vue&type=template&id=f73b81a2&scoped=true&"
import script from "./TutorialDocent.vue?vue&type=script&lang=js&"
export * from "./TutorialDocent.vue?vue&type=script&lang=js&"
import style0 from "./TutorialDocent.vue?vue&type=style&index=0&id=f73b81a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73b81a2",
  null
  
)

export default component.exports